import '../../js/src/slick-sliders';
import { debounce  } from 'throttle-debounce';

class videoSlider {
    config = {
        container: null,
        slider: null,
        slide: null,
        dots: null,
        controls: null,
        layout: null,
        mobile: null
    }
    constructor(container, slider, slide, dots, controls) {
        let _t = this;
        _t.bindElements(container, slider, slide, dots, controls);
        _t.initVideoSlider();
    }
    bindElements(container, slider, slide, dots, controls){
        let _t = this;
        // Bind relevant elements for video slider functionality
        _t.config.container = $(container);
        _t.config.slider    = _t.config.container.find(slider);
        _t.config.slide     = _t.config.container.find(slide);
        _t.config.dots      = _t.config.container.find(dots);
        _t.config.controls  = _t.config.container.find(controls);
        _t.config.layout    = _t.config.container.data('layout');
        _t.config.mobile    = ($(window).width() < 1200 ? true : false);
    }
    bindEventHandlers(){
        let _t      = this;
        if(_t.config.layout === 'landscape'){
            // Slide hover and click functionality
            _t.config.slide.each((i,e) => {
                $(e).unbind();
                // On mouse enter on slide set as current slide
                $(e).on('mouseenter', () => {
                    if(!$(e).parents('.slick-slide').hasClass('slick-current')){
                        $('.slick-slide').not($(e).parents('.slick-slide')).addClass('non-active');
                        $(e).parents('.slick-slide').addClass('active');
                    }
                });
                // On mouse leave unset slide as current slide
                $(e).on('mouseleave', () => {
                    $('.slick-slide').not($(e).parents('.slick-slide')).removeClass('non-active');
                    $(e).parents('.slick-slide').removeClass('active');
                });
            });
        }
        _t.config.controls.find('.slick-slider__navigation--prev').unbind();
        // Slider navigation returns to the previous slide on click
        _t.config.controls.find('.slick-slider__navigation--prev').on('click', () => {
            _t.config.slider.slick('slickPrev')
        });
        _t.config.controls.find('.slick-slider__navigation--next').unbind();
        // Slider navigation moves to the next slide on click
        _t.config.controls.find('.slick-slider__navigation--next').on('click', () => {
            _t.config.slider.slick('slickNext')
        });
        // Slide click functionality
        _t.config.slide.each((i,e) => {
            $(e).find('.video-slider__icon').unbind();
            $(e).find('.video-slider__icon').on('click', () => {
                _t.playVideo($(e).find('.video-slider__video'), $(e).find('.video-slider__icon'), $(e).find('img'), $(e).find('.video-slider__content'), $(e).find('iframe'));
            });
        });
        $(window).resize(debounce (500, () => {
            _t.config.mobile = ($(window).width() < 1200 ? true : false);
            _t.initVideoSlider();
        }));
    }
    playVideo(parent, button, image, content, iframe){
        // Remove pointer events from overlay
        parent.addClass('active');
        // Hide slide button, image and content
        button.hide();
        image.hide();
        content.hide();
        // Set video src
        iframe.attr('src', iframe.attr('src') + '&autoplay=1&mute=1');
        // Show video
        iframe.css('opacity', 1);
    }
    // Init Video Slider
    initVideoSlider(){
        let _t = this;
        if(_t.config.layout === 'landscape' && !_t.config.slider.hasClass('slick-initialized')){
            _t.config.slider.slick(_t.returnSliderConfig());
        } else if(_t.config.mobile && _t.config.layout === 'portrait' && !_t.config.slider.hasClass('slick-initialized')){
            _t.config.slider.slick(_t.returnSliderConfig());
        } else if(!_t.config.mobile && _t.config.layout === 'portrait' && _t.config.slider.hasClass('slick-initialized')){
            _t.config.slider.slick('unslick');
        }
        _t.bindEventHandlers();
    }
    // Return slick slider config
    returnSliderConfig(){
        let _t = this;
        // Return config specific to video slider layout
        if(_t.config.layout === 'landscape'){
            return {
                infinite: false,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                dots: true,
                focusOnSelect: true,
                touchThreshold: 200,
                appendDots: _t.config.dots,
                mobileFirst: true,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            swipe: true
                        }
                    }
                ]
            }
        } else {
            return {
                infinite: false,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                dots: true,
                focusOnSelect: true,
                touchThreshold: 200,
                appendDots: _t.config.dots,
                mobileFirst: true,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            swipe: true
                        }
                    }
                ]
            }
        }
    }
}
$(() => {
    if($('.video-slider').length) var video_slider = new videoSlider('.video-slider', '.video-slider__slider','.video-slider__slide', '.slick-slider__dots', '.slick-slider__navigation');
});